import React, { lazy } from "react";
import { Route } from "react-router-dom";
import { AuthLayout } from "../layouts/AuthLayout";

const LoginPage = lazy(() => import("../pages/auth/LoginPage").then(m => ({ default: m.LoginPage })));
const AdminLoginPage = lazy(() => import("../pages/auth/LoginPage").then(m => ({ default: m.AdminLoginPage })));
const FacultyLoginPage = lazy(() => import("../pages/auth/LoginPage").then(m => ({ default: m.FacultyLoginPage })));
const StudentLoginPage = lazy(() => import("../pages/auth/LoginPage").then(m => ({ default: m.StudentLoginPage })));
const ParentLoginPage = lazy(() => import("../pages/auth/LoginPage").then(m => ({ default: m.ParentLoginPage })));
const StaffLoginPage = lazy(() => import("../pages/auth/LoginPage").then(m => ({ default: m.StaffLoginPage })));
const PortalSelectorPage = lazy(() => import("../pages/auth/PortalSelectorPage"));
const RegisterPage = lazy(() => import("../pages/auth/RegisterPage").then(m => ({ default: m.RegisterPage })));
const ForgotPasswordPage = lazy(() => import("../pages/auth/ForgotPasswordPage").then(m => ({ default: m.ForgotPasswordPage })));
const VerifyEmailPage = lazy(() => import("../pages/auth/VerifyEmailPage").then(m => ({ default: m.VerifyEmailPage })));
const AccessDeniedPage = lazy(() => import("../pages/auth/AccessDeniedPage").then(m => ({ default: m.AccessDeniedPage })));
const SessionExpiredPage = lazy(() => import("../pages/auth/SessionExpiredPage").then(m => ({ default: m.SessionExpiredPage })));
const SetupWizardPage = lazy(() => import("../pages/setup/SetupWizardPage").then(m => ({ default: m.SetupWizardPage })));
const ResetPasswordPage = lazy(() => import("../pages/auth/ResetPasswordPage").then(m => ({ default: m.ResetPasswordPage })));

export const renderAuthRoutes = () => (
  <>
    <Route path="/setup" element={<SetupWizardPage />} />
    <Route path="/portals" element={<PortalSelectorPage />} />

    <Route element={<AuthLayout />}>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/admin" element={<AdminLoginPage />} />
      <Route path="/login/faculty" element={<FacultyLoginPage />} />
      <Route path="/login/student" element={<StudentLoginPage />} />
      <Route path="/login/parent" element={<ParentLoginPage />} />
      <Route path="/login/staff" element={<StaffLoginPage />} />

      {/* Legacy Portal Route Aliases */}
      <Route path="/login/administrator" element={<AdminLoginPage />} />
      <Route path="/login/principal" element={<AdminLoginPage />} />
      <Route path="/login/dean" element={<AdminLoginPage />} />
      <Route path="/login/hod" element={<AdminLoginPage />} />
      <Route path="/login/exam" element={<AdminLoginPage />} />
      <Route path="/login/examcell" element={<AdminLoginPage />} />
      <Route path="/login/research" element={<FacultyLoginPage />} />
      <Route path="/login/accountant" element={<StaffLoginPage />} />
      <Route path="/login/librarian" element={<StaffLoginPage />} />
      <Route path="/login/hostel" element={<StaffLoginPage />} />
      <Route path="/login/placement" element={<StaffLoginPage />} />
      <Route path="/login/hr" element={<StaffLoginPage />} />
      <Route path="/login/transport" element={<StaffLoginPage />} />
      <Route path="/login/itsupport" element={<StaffLoginPage />} />
      <Route path="/login/support" element={<StaffLoginPage />} />
      <Route path="/portal/:role" element={<AdminLoginPage />} />

      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      <Route path="/session-expired" element={<SessionExpiredPage />} />
    </Route>
  </>
);

